'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import styles from './HeaderBackground.module.scss';

const HeaderBackground = () => {
  const pathname = usePathname();

  useEffect(() => {
    const segments = pathname.split('/');
    const isIngredientsPage = segments[2] === 'ingredients';
    const isHomePage = segments.length === 2;

    document.body.classList.toggle(styles.headerBackground, !isHomePage);
    document.body.classList.toggle(styles.opacity, isIngredientsPage);

    return () => {
      document.body.classList.remove(styles.headerBackground, styles.opacity);
    };
  }, [pathname]);

  return null;
};

export default HeaderBackground;
